import { render, staticRenderFns } from "./dataTopic.vue?vue&type=template&id=f943b3e2"
import script from "./dataTopic.vue?vue&type=script&lang=js"
export * from "./dataTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports